import React from 'react'
import useStore from 'state/knovStore'

const Connector =
    (stateSelector, getConnectorProps = /** @type {(props: any) => any} */ (() => ({}))) =>
    WrappedComponent =>
        React.forwardRef((props, ref) => {
            const connectorProps = getConnectorProps(props)
            const combinedProps = { ...connectorProps, ...props }
            const selectedState = useStore(
                /** @type {(state: any) => any} */
                (state => stateSelector(state, combinedProps)),
            )

            return <WrappedComponent ref={ref} {...props} {...selectedState} {...connectorProps} />
        })

export default Connector
